import styles from "./NewFooterUI.module.scss";
import unmeteredGif from "../../../assets/images/unmetered-gif.gif";
const CheckoutFooter = () => {
  return (
    <footer className={styles.checkout_footer}>
      <div
        className={styles.footer}
        style={{ borderTop: "0.5px solid #333333" }}
      >
        <div
          className={styles.sixth_row}
          style={{ padding: "20px 0", margin: "0" }}
        >
          <div className="container">
            {" "}
            <div className={styles.sixth_row_data}>
              <span>© Copyright 2025. All Rights Reserved.</span>
              <div className={styles.fourth_row_data}>
                <a href="/privacy-policy">Privacy Policy</a>
                <a href="/term-conditions">Terms & Conditions</a>
                <a href="/cancellation-policy">Cancellation Policy</a>
                <a href="/disclaimer">Disclaimer</a>
              </div>
              <span
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                Powered by{" "}
                <a href="https://unmeteredtechnologies.com/" target="_blank">
                  {" "}
                  <img
                    src={unmeteredGif}
                    alt="unmetered-logo"
                    style={{ height: "auto", width: "75px" }}
                  />
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CheckoutFooter;
